import { atom } from 'jotai'

import { InvoiceStatus } from '@sequencehq/invoice-content'
import { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'

type ResolutionBody =
  Dashboardv99990101Api.PostInvoiceReminderVariableResolution.Body

import { validateFields } from 'Automations/nodeDefinitions/validation'
import {
  subjectRequired,
  templateRequired,
  toRequired,
  validEmailRecipients
} from '../../../reminder.validators'

export const toAtom = atom<string[]>([])
export const ccAtom = atom<string[]>([])
export const bccAtom = atom<string[]>([])
export const subjectAtom = atom<string>('')
export const bodyAtom = atom<string>('')

export const invoiceIdAtom = atom<string>('')

/**
 * The full invoice / customer objects from the task input, posted to the
 * variable-resolution endpoint to preview the email as it would send.
 */
export const invoiceProjectionAtom = atom<
  ResolutionBody['invoice'] | undefined
>(undefined)
export const customerProjectionAtom = atom<
  ResolutionBody['customer'] | undefined
>(undefined)
export const invoiceNumberAtom = atom<string>('')
export const invoiceStatusAtom = atom<InvoiceStatus>('SENT')
export const invoiceCustomerLegalNameAtom = atom<string>('')

/**
 * Validation
 */
const EMAIL_REVIEW_VALIDATION = {
  to: { ERROR: [toRequired, validEmailRecipients], WARN: [] },
  cc: { ERROR: [validEmailRecipients], WARN: [] },
  bcc: { ERROR: [validEmailRecipients], WARN: [] },
  subject: { ERROR: [subjectRequired], WARN: [] },
  body: { ERROR: [templateRequired], WARN: [] }
}

export const showValidationErrorsAtom = atom(false)

export const validationErrorsAtom = atom(get =>
  validateFields(
    {
      to: get(toAtom),
      cc: get(ccAtom),
      bcc: get(bccAtom),
      subject: get(subjectAtom),
      body: get(bodyAtom)
    },
    EMAIL_REVIEW_VALIDATION
  )
)

export const hasValidationErrorsAtom = atom(get =>
  Object.values(get(validationErrorsAtom)).some(results => results.length > 0)
)
